<template>
    <div style="display: flex;flex-direction: row; align-items: center;height: 50px;">
        <img :src="icon" style="width: 50px;height: 50px;" />
        <div style="display: flex;flex-direction: column;">
            <div style="display: flex;align-items: center;">
                <div style="font-size: 14px;color: #0F1A3A;font-weight: bold;">{{ title }}</div> 
                <img v-if="isRealData && languageId==1"
                    :src="imgIconShishi" style="width: 32px;height: 17px;margin-left: 4px;" />
                     <img v-if="isRealData && languageId==3"
                    :src="imgIcShishiEnglish2x" style="width: 60px;height: 17px;margin-left: 4px;" />
                       <img v-if="isRealData && languageId==5"
                    :src="imgIcShishiXibanya2x" style="width: 75px;height: 17px;margin-left: 4px;" />
            </div>
            <div style="display: flex;align-items: flex-end;">
                <div style="font-size: 24px;margin-top: 6px;" :style="{ 'color': color }">{{ value }}</div>
                <div v-if="extValue" style="font-size: 10px;color: #0F1A3A;margin-left: 6px;">{{ extValue }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import language from '@/utils/getLanguageId';
import imgIconShishi from "@/assets/images/icon_shishi.png";
import imgIcShishiEnglish2x from "@/assets/images/ic_shishi-english@2x.png";
import imgIcShishiXibanya2x from "@/assets/images/ic_shishi_xibanya@2x.png";
export default {
    props: {
        isRealData: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: '#2A7AFF'
        },
        icon: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '车辆总数'
        },
        value: {
            type: Number,
            default: 0
        },
        extValue: {
            type: String,
            default: ''
        }
    },   
    data() {
        return {
            imgIconShishi,
            imgIcShishiEnglish2x,
            imgIcShishiXibanya2x
        }
    },
    computed: {
      languageId(){
        return language(this.$store.getters.locale)

      }
        
    }
}
</script>
